<template>
  <div class="unsure-callout-block callout-block">

    <div class="callout-block-heading">
      <svg class="block-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
        <path fill="#0061A6" d="M24.31,29.35c-0.74,0-1.28-0.54-1.38-1.28l-0.32-2.75c-0.13-0.86,0.38-1.5,1.25-1.6c3.01-0.29,4.67-1.44,4.67-3.46V20.2c0-1.79-1.38-3.04-3.68-3.04c-1.7,0-3.07,0.61-4.35,1.76c-0.32,0.26-0.74,0.45-1.18,0.45c-0.99,0-1.79-0.8-1.79-1.76c0-0.48,0.19-0.99,0.64-1.38c1.7-1.6,3.84-2.66,6.78-2.66c4.48,0,7.52,2.5,7.52,6.5v0.06c0,4.03-2.91,5.86-6.46,6.46l-0.13,1.47c-0.13,0.7-0.64,1.28-1.38,1.28H24.31z M24.31,31.69c1.31,0,2.27,0.96,2.27,2.21v0.32c0,1.25-0.96,2.21-2.27,2.21c-1.31,0-2.27-0.96-2.27-2.21V33.9C22.04,32.65,23,31.69,24.31,31.69z"/>
        <path fill="#D91C1C" d="M25,4c7.76,0,14.53,4.24,18.17,10.51l3.48-2.01C42.33,5.03,34.25,0,25,0S7.67,5.03,3.35,12.5l3.48,2.01C10.47,8.24,17.24,4,25,4z"/>
        <path fill="#FFAC26" d="M46,25c0,11.58-9.42,21-21,21v4c13.81,0,25-11.19,25-25c0-4.55-1.22-8.82-3.35-12.5l-3.48,2.01C44.96,17.6,46,21.18,46,25z"/>
        <path fill="#00C2AE" d="M25,50v-4C13.42,46,4,36.58,4,25c0-3.82,1.04-7.4,2.83-10.49L3.35,12.5C1.22,16.18,0,20.45,0,25C0,38.81,11.19,50,25,50z"/>
      </svg>
      <div class="callout-block-heading-copy">
        <div class="callout-block-heading-copy-eyebrow">Question</div>
        <div class="callout-block-heading-copy-title">{{ $t('unsure-about-your-model') }}</div>
      </div>
    </div>

    <div class="callout-block-typography-section typography">
      <p v-if="$i18n.locale === 'fr'">
        Si vous avez des doutes au sujet du modèle principal du programme, consultez le Tableau du cadre bilatéral :  <em>Contextualisation des relations de mentorat dans les programmes formels de mentorat des jeunes</em>. Si vous avez besoin de soutien additionnel pour identifier le modèle principal, contactez-nous.
      </p>
      <p v-else>
        If you are unsure about your program's primary model, consult the <em>Bilateral Framework Table: Contextualizing Mentoring Relationships Within Formal Youth Mentoring Programs</em>. If you need additional help to determine your primary program model, contact us.
      </p>
    </div>

    <div class="callout-block-actions callout-block-actions-no-label">
      <div class="callout-block-actions-label"></div>
      <div class="callout-block-actions-buttons">
        <a href="mailto:ben.dantzer@mentoringcanada.ca">
          <button type="button" class="rect outline">{{ $t('contact-us') }}</button>
        </a>
        <a target="_blank" :href="$t('contextual-framework-link')">
          <button type="button" class="rect">{{ $t('consult-the-framework') }}</button>
        </a>
      </div>
    </div>

  </div>
</template>
